import React from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import placeholderImage from "./../../assets/img/property-placeholder.jpg";
import { Search } from "@material-ui/icons";
import { connect } from "react-redux";
import { getTaskList } from "./../../actions/DashboardActions";
import moment from "moment";
import ImageLoader from "react-load-image";
import UrlConstants from "./../../config/UrlConstants";
import loaderImage from "../../assets/img/Ring-Preloader.gif";
import { getTimeFromMins, formatPhoneNumber } from "./../Common/Common";
import TablePagination from "@material-ui/core/TablePagination";

function Preloader(props) {
  return <img src={loaderImage} />;
}

class AllTaskList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transactionEvent: [],
      taskType: "",
      showLoader: true,
      filteredTransactionEvent: [],
      searchParam: "",
      recordPerPage: 2,
      page: 0,
    };
  }

  componentWillMount() {
    this.getAllTask(this.state.page);
  }
  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
    this.setState({ showLoader: false });
  }
  getAllTask(pageIndex) {
    this.setState({ taskType: localStorage.getItem("taskType") });
    this.props
      .getTaskList(
        localStorage.getItem("taskType"),
        this.state.recordPerPage,
        pageIndex
      )
      .then((res) => {
        this.setState({
          transactionEvent: res.transactionsEvent || [],
          filteredTransactionEvent: res.transactionsEvent || [],
        });
      })
      .catch((err) => {});
  }
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.getAllTask(newPage);
    });
  };
  search(param) {
    param = param.trim().replace(/\s/g, "");
    var tasks = [];
    tasks = this.state.filteredTransactionEvent.filter((o) => {
      var found = false;
      Object.keys(o).forEach((v) => {
        if (v == "title" || v == "communicationTo") {
          let item = o[v] + "";
          item = item.replace(/\s/g, "");
          if (item.toLowerCase().includes(param.toLowerCase())) {
            found = true;
          }
        } else if (v == "transactionData") {
          let street = o[v].property.street + "";
          street = street.replace(/\s/g, "");
          let street1 = o[v].property.street1 + "";
          street1 = street1.replace(/\s/g, "");

          if (
            street.toLowerCase().includes(param.toLowerCase()) ||
            street1.toLowerCase().includes(param.toLowerCase())
          ) {
            found = true;
          }
        }
      });

      return found;
    });
    this.setState({
      transactionEvent: tasks,
      searchParam: param,
    });
  }
  goToTaskDetails(id, transactionId) {
    this.props.history.push({
      pathname: "/artwork/detail/" + transactionId,
      taskId: id,
    });
  }
  render() {
    var tasks = this.state.transactionEvent;

    var title = "";
    if (this.state.taskType === "OVERDUE") {
      title = "Overdue Tasks";
    } else if (this.state.taskType === "NOT DUE") {
      title = "Scheduled Tasks";
    } else {
      title = "Scheduled & Overdue Tasks";
    }
    return (
      <div className="dash-col dash-col-big" style={{ width: "100%" }}>
        <div className="dash-col-inner">
          <div className="dash-col-head with-border">
            <Row className="align-items-center">
              <Col>
                <h4 className="color-blue-3 font-16 font-600 mb-0">{title}</h4>
              </Col>
              <Col align="right" className="col-auto">
                <div className="icon-wrapper">
                  <Form.Control
                    type="text"
                    className="form-control-head"
                    placeholder="Search"
                    value={this.state.searchParam}
                    onChange={(e) => {
                      this.search(e.target.value);
                      this.setState({ searchParam: e.target.value });
                    }}
                  />
                  <span className="form-control-icn">
                    <Search />
                  </span>
                </div>
              </Col>
            </Row>
          </div>
          {this.state.showLoader ? (
            <div className="page-loader">
              <div className="page-loader-inner">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          ) : tasks.length == 0 ? (
            <div className="dash-no-records">No Records Found</div>
          ) : (
            <div className="upc-task upc-task-type">
              <div className="upc-task-row upc-task-row-head">
                <div className="upc-task-col">Due Date and Time</div>
                <div className="upc-task-col">Task</div>
                <div className="upc-task-col">Transaction</div>
                <div className="upc-task-col">Assignee</div>
              </div>
              <div className="upc-task-row-body">
                {tasks.map((task, i) => {
                  return (
                    <div className="upc-task-row task-row">
                      <div className="upc-task-col">
                        {moment(task.eventEndDate).format("MM/DD/YYYY") +
                          " " +
                          getTimeFromMins(task.time)}
                      </div>
                      <div className="upc-task-col">
                        <div
                          className="clickable"
                          onClick={() => {
                            this.goToTaskDetails(
                              task._id,
                              task.transactionData._id
                            );
                          }}
                        >
                          {task.title}
                        </div>
                      </div>

                      {task.transactionData && (
                        <div className="upc-task-col">
                          <div
                            className="trans-combo clickable"
                            onClick={() => {
                              this.props.history.push(
                                "/artwork/detail/" + task.transactionData._id
                              );
                            }}
                          >
                            <div className="trans-img">
                              {task.transactionData.property.image == null ||
                              task.transactionData.property.image.length <= 0 ||
                              task.transactionData.property.image[0] == "" ? (
                                <img src={placeholderImage} />
                              ) : (
                                <ImageLoader
                                  src={
                                    UrlConstants.AdminCreateTransactionUrl +
                                    "/upload?id=" +
                                    task.transactionData.ownerId +
                                    "&img=" +
                                    task.transactionData.property.image[0]
                                  }
                                >
                                  <img />
                                  <img src={placeholderImage} />
                                  <Preloader />
                                </ImageLoader>
                              )}
                            </div>
                            <div className="trans-info">
                              <h5>
                                {task.transactionData.property.street +
                                  (task.transactionData.property.street1 != ""
                                    ? ", " +
                                      task.transactionData.property.street1 +
                                      ""
                                    : "")}
                              </h5>
                              <p>
                                {task.transactionData.property.city +
                                  ", " +
                                  (task.transactionData.property.state
                                    ? task.transactionData.property.state + " "
                                    : "") +
                                  task.transactionData.property.zipcode}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="upc-task-col">
                        {!!task.assigneeData
                          ? task.assigneeData.firstname +
                            " " +
                            task.assigneeData.lastname
                          : task.communicationTo[0] !== "" &&
                            task.communicationTo.length > 0
                          ? !isNaN(task.communicationTo)
                            ? formatPhoneNumber(task.communicationTo.join(","))
                            : task.communicationTo.join(",")
                          : task.assignee}
                      </div>
                    </div>
                  );
                })}
                <TablePagination
                  component="div"
                  count={this.props.totalTasks}
                  page={this.state.page}
                  onChangePage={this.handleChangePage}
                  rowsPerPage={this.state.recordPerPage}
                  rowsPerPageOptions={[]}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    taskList: state.reducer.taskList,
    totalTasks: state.reducer.totalTasks,
  };
};

export default connect(
  mapStateToProps,
  { getTaskList }
)(AllTaskList);
